module.exports = __webpack_public_path__ + "img/sticker_11.606b5f2e.svg";